module.exports = __webpack_public_path__ + "img/events-1.10285ff7.jpg";